import { Tab, Tabs } from '@mui/material';
import { Outlet, Link as RouteLink, useLocation } from 'react-router';
import { useAuthStore } from '../../stores/auth/auth.store';

const GruposAgrupacionesArticulos = () => {
  const { permisos } = useAuthStore();
  const { pathname } = useLocation();
  const currentTab = pathname.split('/').pop();
  const tieneAccesoGrupos = permisos.some(
    (permiso) => permiso.idModulo === 'grupos-articulos' && permiso.idPermiso === 'acceso'
  );
  const tieneAccesoAgrupaciones = permisos.some(
    (permiso) => permiso.idModulo === 'agrupaciones-articulos' && permiso.idPermiso === 'acceso'
  );
  return (
    <>
      <Tabs value={currentTab}>
        {tieneAccesoGrupos && (
          <Tab
            label="Grupos"
            value="grupos"
            to="/grupos-agrupaciones-articulos/grupos"
            component={RouteLink}
          />
        )}
        {tieneAccesoAgrupaciones && (
          <Tab
            label="Agrupaciones"
            value="agrupaciones"
            to="/grupos-agrupaciones-articulos/agrupaciones"
            component={RouteLink}
          />
        )}
      </Tabs>
      <Outlet />
    </>
  );
};

export default GruposAgrupacionesArticulos;
